import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ITEM_ATA.ADITAMENTO.ADITAR.INSERIR_PERCENTUAL]({ state }) {
		await api.aditamento.inserirPercentual(state)
	},
}
